import { render, staticRenderFns } from "./SideBarReport.vue?vue&type=template&id=d023f2b6&scoped=true&"
import script from "./SideBarReport.vue?vue&type=script&lang=js&"
export * from "./SideBarReport.vue?vue&type=script&lang=js&"
import style0 from "./SideBarReport.vue?vue&type=style&index=0&id=d023f2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023f2b6",
  null
  
)

export default component.exports